export default __webpack_public_path__ + "static/media/money-stack-o.73674901.svg";